module.exports = __webpack_public_path__ + "img/cafeteria.c38a3628.svg";